import { Component } from '@angular/core';

@Component({
  selector: 'app-atmospheric-environment',
  templateUrl: './atmospheric-environment.component.html',
  styleUrls: ['./atmospheric-environment.component.css']
})
export class AtmosphericEnvironmentComponent { }